export const pekkasounds: string[][] = [
    [ "aarne1.mp3", "Arje1"],
    [ "aarne2.mp3", "Arje2"],
    [ "ahvenanmaa.mp3", "mutakuonot ahvenanmaalle"],
    [ "arjalaisia.mp3", "ruotsalaiset ovat tosiarjalaisia"],
    [ "arjalaisiaenammu.mp3", "arjalaisia en ammu, mutta..."],
    [ "ausvits.mp3", "Auschwitzissä mitään ollut"],
    [ "erittainpaljon.mp3", "vähemmistöt?"],
    [ "fasisteja.mp3", "poliisien joukossa..."],
    [ "fasistinen.mp3", "fasistipuolue?"],
    [ "germaani.mp3", "germaaninen esi-isä"],
    [ "goodmorning.mp3", "good morning"],
    [ "guru.mp3", "olen guru"],
    [ "hehheh.mp3", "hehheh"],
    [ "helvetinhyvin.mp3", "nyt näkyy helvetin hyvin"],
    [ "hienostisanottu.mp3", "se on hienosti sanottu"],
    [ "hitlerh.mp3", "suurmies Adolf Hitler"],
    [ "homolordi.mp3", "homoloordi"],
    [ "humanist.mp3", "juu aa humanist juuden"],
    [ "hyvaapaivaa.mp3", "hyvää päivää!"],
    [ "isanmaallinen.mp3", "isänmaallinen?"],
    [ "jeesushumanisti.mp3", "Jeesus on humanisti"],
    [ "judenagent.mp3", "Churchhill oli homo"],
    [ "juutalaisongelma.mp3", "juutalaisongelma?"],
    [ "kansallinenrintama.mp3", "kansallinen rintama"],
    [ "kieroilemaan.mp3", "vierasrotuiset kieroilemaan"],
    [ "kissoja.mp3", "kissojen keittämisestä"],
    [ "kivenkova.mp3", "olen kivenkova..."],
    [ "kommunistit.mp3", "en ole natsipelle"],
    [ "kukaminaolen.mp3", "kuka minä olen?"],
    [ "laulua.mp3", "*laulua*"],
    [ "magnumit.mp3", "magnumit on aina valmiina"],
    [ "marssiminen.mp3", "vaikea marssia"],
    [ "minapekka.mp3", "minä, Pekka Siitoin"],
    [ "mustalaiset.mp3", "we are patriootteja"],
    [ "mutakuonoja.mp3", "olemme natseja"],
    [ "mutakuonojaa.mp3", "yksikään mutakuono ei"],
    [ "nainonmarjat.mp3", "näin on marjat"],
    [ "natsivalta.mp3", "Suomessa natsivalta?"],
    [ "pakolaispolitiikkaa.mp3", "ruotsin pakolaispolitiikka"],
    [ "parvekeauki.mp3", "Jaska, parveke auki!"],
    [ "ratkeeneekeriin.mp3", "ratkeaa neekeriin"],
    [ "rivologi.mp3", "olen irstailija"],
    [ "ruotsalaisethie.mp3", "ruotsalaiset hienoa rotua"],
    [ "ruotsalaisista.mp3", "90% ruotsalaisista on homoja"],
    [ "ryssat.mp3", "10 miljoonaa ryssää"],
    [ "saalionsairautta.mp3", "sääli on sairautta"],
    [ "saatanaelaa.mp3", "Saatana elää"],
    [ "sick.mp3", "aim sick"],
    [ "siegheil.mp3", "Sieg Heil Väinö!"],
    [ "siegheil2.mp3", "Sieg Heil"],
    [ "siitoin.mp3", "Siitoin, Heil Hitler"],
    [ "taistelen.mp3", "ikuiseen taistoon"],
    [ "tonttuja.mp3", "mustia tonttuja"],
    [ "totaalit.mp3", "totaalikieltäytyjät"],
    [ "valkoiset.mp3", "musta enemmistö"],
];